$(document).ready(function(e){
  SITE.setForm();
  SITE.setMenu();
  SITE.setGoTo();

  $(window).scroll( function(e){
    SITE.checkOnScroll(e);
  });
  SITE.checkOnScroll(e);

  $(window).resize(function(e) {
    SITE.checkOnResize(e);
  });
  SITE.checkOnResize(e);
  

  $('._not_load').removeClass('_not_load');
});

var SITE = Object();


SITE.checkOnScroll = function(){
  
}

SITE.checkOnResize = function(e){
  
}


SITE.setGoTo = function(){
  $('[goto]').click(function(e){
    e.preventDefault();
    var goto = $(this).attr('goto');
    $('body,html').animate({scrollTop:$(goto).offset().top-70},1000);
  });
  $('.scrollUp').click(function(e){
    e.preventDefault();
    $('body,html').animate({scrollTop:0},1000);
  });
  
  $('[href^="#"],[href^="/#"]').click(function(e){
    if(
      typeof $(this).attr('href').split('#')[1] !== 'undefined' && 
      $(this).attr('href').split('#')[1]!='' &&
      $('#' + $(this).attr('href').split('#')[1]).length > 0
    ){
      e.preventDefault();
      var goto = $(this).attr('href').split('#')[1];
      $('body,html').animate({scrollTop:$('#'+goto).offset().top-0},1000);

      SITE.closeMenu();
    }
  });
  $('.bigPic .tarjeta .cuadro').click(function(e){
    e.preventDefault();
    $('body,html').animate({scrollTop:$('#cotiza').offset().top-55},1000);
  });
}

SITE.closeMenu = function(){
  $('body').removeClass('_menu_open');
  $('.menuCustom.active').removeClass('active');
}
SITE.setMenu = function(){
  $('.nav-mobile .wrap .sw').click(function(e){
    $('body').toggleClass('_menu_open');
    $('.menuCustom').addClass('active');
  });
  $('#menu').click(function(e){
    $('body').toggleClass('_menu_open');
  });
}

SITE.setForm = function(){
  $(document).on('focus','form .field .input input',function(){
    $(this).parentsUntil('.field').parent().find('.input').addClass('focus');
  });
  $(document).on('blur','form .field .input input',function(){
    $(this).parentsUntil('.field').parent().find('.input').removeClass('focus');
  });






  $(document).on('click','.select .head',function(){
    var $t = $(this).parent();
    if($t.is('._open')){
      $t.find('.options').slideUp().promise().done(function(){
        $t.removeClass('_open');
      });
    }else{
      $t.find('.options').slideDown().promise().done(function(){
        $t.addClass('_open');
      });
    }
  });

  
  // document.getElementById("contact_form").addEventListener("submit", function(e) {
  //   e.preventDefault();

  //   const email = this.querySelector('input[name="contact[email]"]').value;

  //   fetch('/contact#contact_form', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded'
  //     },
  //     body: new URLSearchParams({
  //       'form_type': 'customer',
  //       'utf8': '✓',
  //       'contact[email]': email
  //     })
  //   })
  //   .then(response => {
  //     console.info(response);
  //     if (response.ok) {
  //       document.getElementById("newsletter-response").innerHTML = "✅ ¡Gracias por suscribirte!";
  //       // this.reset();
  //     } else {
  //       document.getElementById("newsletter-response").innerHTML = "❌ Hubo un error. Intenta de nuevo.";
  //     }
  //   });
  // });
  
}



SITE.limpiarErrors = function(e){
  $('form .error').slideUp();
}
SITE.deshabilitarBoton  = function($e){
  $e.prop('disabled', true);
  $e.addClass('_disable');
}
SITE.habilitarBoton  = function($e){
  $e.prop('disabled', false);
  $e.removeClass('_disable');
}



SITE.closeModal = function(){
  $('.overModal .modal').fadeOut(500).promise().done(function(){
    $('.overModal').fadeOut(500)
  })
}

SITE.openModal = function(){
  $('.overModal').fadeIn(500).promise().done(function(){
    $('.overModal .modal').fadeIn(500)
  })
}


document.addEventListener("DOMContentLoaded", function() {
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get("customer_posted") === "true") {
  const successMessage = document.createElement("div");
  successMessage.innerText = "¡Gracias por suscribirte!";
  successMessage.style.color = "green";
  successMessage.style.marginTop = "10px";
  
  const form = document.getElementById("contact_form");
  if (form) {
  form.parentNode.insertBefore(successMessage, form.nextSibling);
  }
}
});
